module.exports = {
    message: {
      hello_world: '世界 你好'
    },
    down: {
        grid_bot: '網格量化工具',
        overcome_emotional: '克服投資情緒',
        fortune_market: '輕鬆穿越牛熊',
        contact_email: '聯繫客服郵箱',
        copy_success: '複製成功',
        copy_failed: '複製失敗',
        press_copy: '請長按邀請碼進行複製',
				overseas: '需要海外',
				register_guide: '註冊美區ID指引',
				recommend:'推薦',
				enterprise:'企業簽名版',
    },
    sign: {
        register_id: '註冊帳號',
        mobile_regist: '手機註冊',
        email_regist: '郵箱註冊',
        input_phone: '請輸入手機號',
        input_email: '請輸入郵箱地址',
        set_password: '請設置密碼',
        password_rule: '8-16位數字、字母組合',
        password_warn: '要同時含有數字和字母，長度要在8-16位之間',
        invite_code: '推薦人邀請碼',
        agree: '我已閱讀並同意',
        user_agr: '《用戶協議》',
        privacy_agr: '《隱私協議》',
        and: '和',
        regist: '註冊',
        agree_warn: '請先閱讀並同意協議',
        already_regist: '已註冊？點擊下載',
        phone_warn: '手機號碼輸入有誤，請重新填寫',
        email_warn: '郵箱格式有誤，請重新填寫',
        input_code: '輸入驗證碼',
        code_sended: '驗證碼已發送至：',
        re_get: '40s後重新獲取',
        regist_success: '恭喜您註冊成功',
        down_app: '下載APP',
        user_exists: '該用戶已存在',
        resend: '重新獲取',
        wrong_code: '驗證碼有誤',
        choose_area: '選擇國家或地區',
        search: '搜索',
    },
    common: {
      jgz: '金果子',
      jgz_down: '金果子下載',
      invite_regist: '邀請註冊',
      open_in_browser: '請在瀏覽器中打開',
      jgz_team: 'JGZ團隊',
      refresh: '點擊重繪',
    },
    invite: {
      scan_down: '掃碼下載金果子APP',
      invite_code: '邀請碼',
      invite: '立即邀請',
      not_apple: '本活動與蘋果公司無關',
      invite_friend: '邀請好友',
      get_bot: '一起量化'
    },
    activity: {
      jgz_activity: 'JGZ 活動',
      failed: '哦呦！ 獲取失敗。',
      course: '教程',
    },
    alarm: {
      how: '如何添加預警？',
      way: '登錄狀態下，打開任意交易對K線頁面，點擊預警按鈕，即可添加價格預警。'
    }
  }
  